import { SERVICES, BOOKING_URL } from "@/data/content";
import { ArrowUpRight } from "lucide-react";
import { SP_WIDGET_ATTRS } from "./BookingButton";

export default function Services() {
  return (
    <section id="services" className="py-28 lg:py-36" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-4">01 · Services</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight">
              Sessions designed around your <em className="italic">constitution</em>, not a checklist.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-base leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
              Every visit begins with a quiet intake — pulse, tongue, breath, the
              way you sit in a chair. From there we build a treatment that meets
              your body where it actually is today.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: "var(--sano-border)" }}>
          {SERVICES.map((s, i) => (
            <article
              key={s.id}
              className="transition-colors hover:bg-[#F0EBE1] flex flex-col group"
              style={{ background: "var(--sano-bg)" }}
              data-testid={`service-${s.id}`}
            >
              {s.image && (
                <div className="aspect-[4/3] overflow-hidden" style={{ background: "var(--sano-border)" }}>
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              )}
              <div className="p-8 lg:p-10 flex flex-col flex-1">
                <div className="eyebrow mb-5">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-serif-display text-3xl mb-3">{s.title}</h3>
                <div className="flex gap-4 text-xs uppercase tracking-widest mb-5" style={{ color: "var(--sano-ink-2)" }}>
                  <span>{s.duration}</span>
                  <span>·</span>
                  <span>{s.price}</span>
                </div>
                <p className="text-sm leading-relaxed mb-7 flex-1" style={{ color: "var(--sano-ink-2)" }}>
                  {s.blurb}
                </p>
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noreferrer"
                  {...SP_WIDGET_ATTRS}
                  className="inline-flex items-center gap-2 text-sm border-b border-current self-start pb-1 hover:gap-3 transition-all"
                  style={{ color: "var(--sano-olive)" }}
                  data-testid={`service-book-${s.id}`}
                >
                  Book this <ArrowUpRight size={14} strokeWidth={1.5} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
